module.exports = __webpack_public_path__ + "0617ccbda766373c12fa10a3c43a10f6.png";